export const SET_NOT_FIRST_TIME_VISIT = 'SET_NOT_FIRST_TIME_VISIT';
export const RECEIVE_CANTEENS = 'RECEIVE_CANTEENS';
export const RECEIVE_STALLS = 'RECEIVE_STALLS';
export const RECEIVE_STALL_PHOTOS = 'RECEIVE_STALL_PHOTOS';
export const TOGGLE_STALL_VIEW = 'TOGGLE_STALL_VIEW';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const TOGGLE_MUSLIM_ONLY = 'TOGGLE_MUSLIM_ONLY';
export const SET_FB_READY = 'SET_FB_READY';
export const RECEIVE_ACCESS_TOKENS = 'RECEIVE_ACCESS_TOKENS';
export const RECEIVE_CURRENT_USER = 'RECEIVE_CURRENT_USER';
export const RECEIVE_RATINGS = 'RECEIVE_RATINGS';
export const CHANGE_RATING = 'CHANGE_RATING';
export const TOGGLE_MEETING_WINDOW = 'TOGGLE_MEETING_WINDOW';
export const TOGGLE_CANTEEN_PANEL = 'TOGGLE_CANTEEN_PANEL';
export const CREATE_MEETING = 'CREATE_MEETING';
export const CANCEL_MEETING = 'CANCEL_MEETING';
export const UPDATE_MEETING = 'UPDATE_MEETING';
export const UPDATE_NEW_MEETING_DATE = 'UPDATE_NEW_MEETING_DATE';
export const UPDATE_NEW_MEETING_TIME = 'UPDATE_NEW_MEETING_TIME';
export const UPDATE_NEW_MEETING_DURATION = 'UPDATE_NEW_MEETING_DURATION';
export const UPDATE_MEETING_CREATOR_TITLE = 'UPDATE_MEETING_CREATOR_TITLE';
export const UPDATE_MEETING_CREATOR_TITLE_PLACEHOLDER = 'UPDATE_MEETING_CREATOR_TITLE_PLACEHOLDER';
export const UPDATE_MEETING_CREATOR_DESCRIPTION = 'UPDATE_MEETING_CREATOR_DESCRIPTION';
export const UPDATE_TIME_MODIFIER_RADIO = 'UPDATE_TIME_MODIFIER_RADIO';
export const UPDATE_DURATION_MODIFIER_RADIO = 'UPDATE_DURATION_MODIFIER_RADIO';
export const LOGOUT = 'LOGOUT';
export const RECEIVE_MEETINGS = 'RECEIVE_MEETINGS';
export const RECEIVE_FACEBOOK_USER = 'RECEIVE_FACEBOOK_USER';
export const JOIN_MEETING = 'JOIN_MEETING';
export const UNJOIN_MEETING = 'UNJOIN_MEETING';
export const BEGIN_LOGIN = 'BEGIN_LOGIN';
export const DONE_LOGIN = 'DONE_LOGIN';
export const SET_MEETING_ID = 'SET_MEETING_ID';
export const SET_GRANTED_PERMISSIONS = 'SET_GRANTED_PERMISSIONS';
export const TOGGLE_FEED = 'TOGGLE_FEED';
export const RECEIVE_MEETING = 'RECEIVE_MEETING';
export const MEETING_NOT_FOUND = 'MEETING_NOT_FOUND';
export const SET_GEOLOCATION_PERMISSION = 'SET_GEOLOCATION_PERMISSION';
export const SET_LOCATION = 'SET_LOCATION';
export const SET_CURRENT_TIME = 'SET_CURRENT_TIME';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js